/* eslint-disable sonarjs/no-clear-text-protocols */
import { AppRoutes, StorageRoutes } from '@bn/dashboard-core/enums';
import { EnvConfig } from '@bn/shared/entities/index';
import { ExternalUrlConfig } from '@bn/web-ui/external-url';

export class ExtUrlConfiguration {
  public urls!: ExternalUrlConfig;

  constructor(envConfig: EnvConfig) {
    this.urls = {
      learn: {
        [AppRoutes.Storage]: {
          [StorageRoutes.root]: `${envConfig.apiDocsBunnyUrl}/storage`,
          [StorageRoutes.fileManager]: `${envConfig.apiDocsBunnyUrl}/storage/dashboard`,
          [StorageRoutes.access]: `${envConfig.apiDocsBunnyUrl}/storage/ftp`,
          [StorageRoutes.replication]: `${envConfig.apiDocsBunnyUrl}/storage/replication`,
          [StorageRoutes.pullZones]: `${envConfig.apiDocsBunnyUrl}/storage/quickstart`,
          [StorageRoutes.errorHandling]: `${envConfig.apiDocsBunnyUrl}/storage/settings#error-handling`,
        },
      },
      docsBunnyNet: {
        apiReference: {
          apiOverview: {
            name: 'BunnyNet Api Docs',
            url: `${envConfig.apiDocsBunnyUrl}/api-reference`,
          },
          StorageOverview: {
            name: 'Storage Api Docs',
            url: `${envConfig.apiDocsBunnyUrl}/api-reference/storage`,
          },
          StreamOverview: {
            name: 'Stream Api Docs',
            url: `${envConfig.apiDocsBunnyUrl}/api-reference/stream`,
          },
        },
        docs: {
          streamWebhook: {
            name: 'Stream Webhook Docs',
            url: `${envConfig.apiDocsBunnyUrl}/stream/webhooks`,
          },
          streamSecurity: {
            name: 'Stream Security Docs',
            url: `${envConfig.apiDocsBunnyUrl}/stream/security`,
          },
          computeScripts: {
            name: 'Compute scripts Docs & Examples',
            url: `${envConfig.apiDocsBunnyUrl}/quickstart`,
          },
          edgeRulesVariableExpansion: {
            name: 'Variable Expansion documentation',
            url: `${envConfig.apiDocsBunnyUrl}/cdn/edge-rules/variable-expansion`,
          },
          bunnyAIImageGeneration: {
            name: 'Bunny AI Image Generation',
            url: envConfig.apiDocsBunnyUrl,
          },
          bunnyAIImageGenerationPromptSuggestions: {
            name: 'Bunny AI Image Generation Prompt Suggestions',
            url: envConfig.apiDocsBunnyUrl,
          },
          bunnyAIImageGenerationBlueprints: {
            name: 'Bunny AI Image Generation Blueprints',
            url: envConfig.apiDocsBunnyUrl,
          },
        },
      },
      supportBunnyNet: {
        hub: {
          engagementScoreTagging: {
            url: `${envConfig.supportBunnyUrl}/hc/en-us/articles/#`,
          },
          streamContentTagging: {
            url: `${envConfig.apiDocsBunnyUrl}/stream/encoding#enable-content-tagging`,
          },
          knowledgeBase: {
            url: envConfig.apiDocsBunnyUrl,
          },
          sslSetupCustomDomain: {
            name: 'Setup SSL tutorial',
            url: `${envConfig.apiDocsBunnyUrl}/cdn/ssl-setup`,
          },
          dnsKnowledgebase: {
            name: 'DNS Knowledgebase',
            url: `${envConfig.apiDocsBunnyUrl}/cdn/dns`,
          },
          bunnyRoutingFilters: {
            name: 'Routing Filters',
            url: `${envConfig.apiDocsBunnyUrl}/cdn/performance/routing-filters`,
          },
        },
      },
      statusBunnyNet: {
        serviceStatus: {
          url: envConfig.statusUrl,
        },
      },
      toolsBunnyNet: {
        diagnosticReportUrl: {
          name: 'Run diagnostic report',
          url: `${envConfig.toolsUrl}/diagnostic-report`,
        },
      },
      externalServices: {
        gtMetrixUrl: {
          name: 'Open GTMetrix',
          url: 'https://www.gtmetrix.com',
        },
        tracerouteUrl: {
          name: 'How to open traceroute',
          url: 'https://bunny.net/docs/cdn/connectivity#502-and-504-errors',
        },
      },
      authenticatorDownloadUrl: {
        android: {
          name: 'Android',
          url: 'http://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en',
        },
        ios: {
          name: 'Iphone',
          url: 'http://apps.apple.com/us/app/google-authenticator/id388497605',
        },
      },
    };
  }

  getUrls(): ExternalUrlConfig {
    return this.urls;
  }
}
